import React from 'react';

export const StudentNotReadingOrEngaging: React.FC = () => {
  return (
    <div className="modal-template student-not-engaging">
      <h3>Student Engagement Alert</h3>
      <p>A student has not been actively reading or engaging with assignments for 7 days.</p>
      <p>Regular reading practice is essential for skill development and retention.</p>
      <div className="activity-chart-placeholder">
        <div className="chart-placeholder">
          [Activity Chart Placeholder]
        </div>
      </div>
      <div className="action-buttons">
        <button className="btn btn-primary">Send Reminder</button>
        <button className="btn btn-secondary">Schedule Check-in</button>
      </div>
    </div>
  );
};

export default StudentNotReadingOrEngaging; 